import React, { createContext, useReducer, useContext, useEffect, useState } from "react";
import ChatboxInfoService from "../services/ChatboxInfoService";
const ChatbotLogo = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="23" viewBox="0 0 32 23">
<path fill="#F2F2F2" fill-rule="evenodd" d="M20.67 0C26.651 0 31.5 4.849 31.5 10.83v.84c0 5.981-4.849 10.83-10.83 10.83H3.42A3.42 3.42 0 0 1 0 19.08v-8.25C0 4.849 4.849 0 10.83 0h9.84zm1.431 15.177a1.466 1.466 0 0 0-1.832-.968 15.25 15.25 0 0 1-4.519.697 15.25 15.25 0 0 1-4.519-.697 1.467 1.467 0 0 0-1.898 1.4v.298c0 1.147.745 2.16 1.84 2.502 1.526.477 3.051.716 4.577.716 1.526 0 3.051-.239 4.577-.716a2.622 2.622 0 0 0 1.84-2.502v-.298c0-.146-.022-.292-.066-.432zM10.021 4.5h-.209a2.812 2.812 0 0 0-.17 5.62l.17.005h.209a2.812 2.812 0 1 0 0-5.625zm11.666 0h-.208a2.812 2.812 0 0 0-.171 5.62l.171.005h.209a2.812 2.812 0 1 0 0-5.625z"/>
</svg>`;
const ConversationState = {
    backEndService: "",
    company: "",
    bot: "",
    channelKey: "",
    session: window.localStorage.getItem("talkr_session"),
    currentUrl: window.location.href,
    mode: "client",
    avatar: ChatbotLogo,
    defaultValues: {},
    language: {},
    chatboxColor: "#0e7aed",
    delay_run_chatbox: "0",
    sound_effect: true,
    notification: true,
    ripple_effect: true,
    path: [],
    data: { messages: [], responses: [], variables: [] },
    loadingResponse: false,
};

console.log("current_url", window.location.href);
const ConversationStateContext = createContext(ConversationState);
const ConversationDispatchContext = createContext(null);

const ConversationReducer = (state, action) => {
    switch (action.type) {
        case "init":
            return { ...state, ...action.payload };
        case "restartConversation":
            return { ...state, data: { ...state.data, messages: [], responses: [] } };
        case "setVariables":
            return { ...state, data: { ...state.data, variables: [...action.payload.variables] } };
        case "addMessage":
            return {
                ...state,
                data: {
                    ...state.data,
                    messages: [...state.data.messages, action.payload.message],
                    responses: [...state.data.responses],
                },
            };
        case "displayMessage":
            const index = action.payload.index;
            const data = { ...state.data };
            return {
                ...state,
                data: {
                    ...state.data,
                    responses: data.responses,
                    messages: data.messages.map((message, idx) => (index == idx ? { ...message, view: 1 } : message)),
                },
            };
        case "addMessagesAndResponsesAndVariableIfPresent":
            return {
                ...state,
                data: {
                    ...state.data,
                    messages: [...state.data.messages, ...action.payload.messages],
                    responses: [...action.payload.responses],
                    variables: [...action.payload.variables],
                },
            };
        case "setChatboxStyle":
            return {
                ...state,
                chatboxColor: action.payload.chatboxColor,
                avatar: action.payload.avatar !== undefined ? action.payload.avatar : state.avatar,
                delay_run_chatbox: action.payload.delay_run_chatbox,
                sound_effect: action.payload.sound_effect,
                notification: action.payload.notification,
                ripple_effect: action.payload.ripple_effect,
            };
        case "setLoading":
            return { ...state, isLoadingResponse: action.payload.response };
        default:
            return state;
    }
};

const ConversationContextProvider = ({ children, config = {} }) => {
    const [state, dispatch] = useReducer(ConversationReducer, { ...ConversationState, ...config });
    const [fetchedInfo, setFetchedInfo] = useState(false);
    var { bot, mode, backEndService, channelKey, company } = state;

    const fetchChatboxColor = async () => {
        channelKey = channelKey ? channelKey : `${company}-${bot}`;
        const uri = backEndService.replace("api/v1", "");
        const response = await ChatboxInfoService.getChannelInfoForChatbox({ backEndService: uri, channelKey });
        const payload = {};
        if (response.color) payload.chatboxColor = response.color;
        if (response.avatar) payload.avatar = response.avatar;
        if (response.delay_run_chatbox) payload.delay_run_chatbox = response.delay_run_chatbox;
        if (response.sound_effect) payload.sound_effect = !!response.sound_effect;
        if (response.notification) payload.notification = !!response.notification;
        if (response.ripple_effect) payload.ripple_effect = !!response.ripple_effect;

        dispatch({ type: "setChatboxStyle", payload });
        setFetchedInfo(true);
    };

    useEffect(() => {
        if (mode == "debug") {
            return;
        }
        fetchChatboxColor();
    }, [bot, mode]);

    return mode === "debug" || fetchedInfo == true ? (
        <ConversationStateContext.Provider value={state}>
            <ConversationDispatchContext.Provider value={dispatch}>{children}</ConversationDispatchContext.Provider>
        </ConversationStateContext.Provider>
    ) : null;
};

export default ConversationContextProvider;

export const useConversationStateContext = () => useContext(ConversationStateContext);
export const useConversationDispatchContext = () => useContext(ConversationDispatchContext);
